<template>
    <div style="padding: 40px">
        <div class="home-item">
            <p class="home-title">工单总数(个)</p>
            <p class="home-value v1">{{info.orderCount || 0}}</p>
            <div class="home-icon bg1">
                <common-icon type="_gongdanzongshu" color="#fff" :size="32"></common-icon>
            </div>
        </div>
        <div class="home-item">
            <p class="home-title">任务总数(个)</p>
            <p class="home-value v2">{{info.taskCount || 0}}</p>
            <div class="home-icon bg2">
                <common-icon type="_renwuzongshu" color="#fff" :size="32"></common-icon>
            </div>
        </div>
        <div class="home-item">
            <p class="home-title">客户总数(家)</p>
            <p class="home-value v3">{{info.customerCount || 0}}</p>
            <div class="home-icon bg3">
                <common-icon type="_kehuzongshu" color="#fff" :size="32"></common-icon>
            </div>
        </div>
        <div class="home-item">
            <p class="home-title">外部用户(个)</p>
            <p class="home-value v4">{{info.internalCount || 0}}</p>
            <div class="home-icon bg4">
                <common-icon type="_waibuyonghu" color="#fff" :size="32"></common-icon>
            </div>
        </div>
        <div class="home-item home-item-last">
            <p class="home-title">内部用户(个)</p>
            <p class="home-value v5">{{info.externalCount || 0}}</p>
            <div class="home-icon bg5">
                <common-icon type="_neibuyonghu" color="#fff" :size="32"></common-icon>
            </div>
        </div>
        <div class="home-chart-container">
            <p class="home-chart-title">最近30天访问量</p>
            <div class="home-chart-box">
                <line-chart :list="list" chartName="访问量"></line-chart>
            </div>
        </div>
    </div>
</template>
<script>
import { totalStatistic, usingCountStatistic } from '@/api/home'
import LineChart from '_v/components/chart/line-chart-normal'
import { ymd } from '_u/helper'
export default {
    name: 'IndexHome',
    data() {
        return {
            info: {
                orderCount: '', // 工单总数
                taskCount: '', // 任务总数
                customerCount: '', // 客户总数
                internalCount: '', // 外部用户
                externalCount: '' // 内部用户
            },
            list: []
        }
    },
    components: { LineChart },
    methods: {
        setData(args) {
            let [info, list] = args
            Object.keys(this.info).forEach(key => {
                this.info[key] = info.data[key] || ''
            })
            let resList = list.data.list,
                chartList = [],
                map = {}
            resList.forEach(el => {
                let date = ymd(el.dateTime)
                if (map[date]) {
                    let item = chartList.find(val => val.name == date) || {}
                    item.value++
                } else {
                    chartList.push({
                        value: parseInt(el.totalCount),
                        name: date
                    })
                    map[date] = true
                }
            })
            this.list = chartList.sort((a, b) => {
                if (a.name > b.name) {
                    return 1
                } else {
                    return -1
                }
            })
        }
    },
    created() {},
    beforeRouteEnter(to, from, next) {
        Promise.all([totalStatistic(), usingCountStatistic()]).then(args => {
            next(vm => vm.setData(args))
        })
    }
}
</script>
<style lang="less" scoped>
@title-color: #515a6e;
.home {
    &-item {
        position: relative;
        display: inline-block;
        height: 130px;
        padding: 30px;
        border-radius: 4px;
        background-color: #fff;
        width: calc(~'(100% - 80px) / 5');
        margin-right: 20px;
        &-last {
            margin-right: 0;
        }
    }
    &-title {
        font-size: 14px;
        color: @title-color;
    }
    &-value {
        font-size: 36px;
        font-weight: bold;
        color: @link-color;
        line-height: 70px;
        &.v1 {
            color: #4585fc;
        }
        &.v2 {
            color: #a584ff;
        }
        &.v3 {
            color: #ff7854;
        }
        &.v4 {
            color: #feb64c;
        }
        &.v5 {
            color: #0fc0d6;
        }
    }
    &-icon {
        position: absolute;
        width: 56px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        border-radius: 50%;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        &.bg1 {
            background-color: #4585fc;
        }
        &.bg2 {
            background-color: #a584ff;
        }
        &.bg3 {
            background-color: #ff7854;
        }
        &.bg4 {
            background-color: #feb64c;
        }
        &.bg5 {
            background-color: #0fc0d6;
        }
    }
    &-chart {
        &-container {
            margin-top: 20px;
            background-color: #fff;
            padding: 20px;
        }
        &-box {
            height: 300px;
        }
        &-title {
            color: #333333;
            line-height: 48px;
            font-size: 14px;
        }
    }
}
</style>